/**
 * Cererile de concediu (Victor, 20.10.2026): preluate automat din mail, doar evidenta.
 * Tipurile si starile, comune serverului si ecranului.
 */
/** „Altele" prinde orice tip care nu e in lista, ca sa nu se ghiceasca unul gresit (Madalin). */
export const TIPURI_CONCEDIU = ['odihna', 'medical', 'fara_plata', 'eveniment', 'altele'];
export const ETICHETE_TIP_CONCEDIU = {
    odihna: 'Odihnă',
    medical: 'Medical',
    fara_plata: 'Fără plată',
    eveniment: 'Eveniment special',
    altele: 'Altele',
};
/**
 * `inregistrata` — citita sigur, sau confirmata de un om;
 * `de_verificat` — ceva n-a fost sigur (motivele stau pe cerere);
 * `nu_e_cerere` — un om a spus ca nu e o cerere de concediu (ascunsa din lista).
 */
export const STARI_CONCEDIU = ['inregistrata', 'de_verificat', 'nu_e_cerere'];
export const ETICHETE_STARE_CONCEDIU = {
    inregistrata: 'Înregistrată',
    de_verificat: 'De verificat',
    nu_e_cerere: 'Nu e cerere',
};
/** `AAAA-LL-ZZ` in UTC — datele de concediu sunt zile, fara ora. */
export function ziIso(d) {
    return d.toISOString().slice(0, 10);
}
/**
 * Codurile de zi din pontajul zilnic al salarizarii (ExpertAccounts) care inseamna ABSENTA, si
 * tipul lor. Restul — ore lucrate, `L` (nelucratoare), `X` (zi inexistenta), `ho` (home office),
 * `d` (delegatie), `lc` (inainte de angajare / dupa plecare) — nu sunt concediu si nu se importa.
 *
 * Cele fara tip propriu (maternitate, suspendare, libere platite) merg la „Altele", cu codul lor.
 */
export const TIP_DIN_COD_PONTAJ = {
    co: 'odihna',
    cb: 'medical',
    cm: 'medical',
    cfs: 'fara_plata',
    m: 'altele',
    sp: 'altele',
    lp: 'altele',
    zlc: 'altele',
    st: 'altele',
};
/** Eticheta codurilor care ajung la „Altele". */
export const ETICHETE_COD_PONTAJ = {
    m: 'maternitate',
    sp: 'suspendat',
    lp: 'liber plătit',
    zlc: 'liber copii',
    st: 'nelucrat, plătit 75%',
};
//# sourceMappingURL=concedii.js.map